import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { ELAutocompleteElement } from '@el-autocomplete';
import {
  DataListTableActionElement,
  DataListTableChipDataElement,
  DataListTableDataElement,
  DataListTableElement,
  DLT_DATA_TYPES,
} from '@el-data-list-table';
import { TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs';

import {
  AttachmentStatus,
  CHIP_BACKGROUND_COLORS,
  FILE_TYPES,
  //FILE_TYPES,
} from '@shared/constants';
import {
  ASSET_CATEGORY_REFERENCE_CATEGORY_FIELD,
  // FILE_TYPES,
  INVENTORY_REFERENCE_CATEGORIES,
  INVENTORY_REFERENCE_SECTION,
  INVENTORY_STATUS,
} from '@shared/constants';
import {
  IAttachmentDocument,
  IConfigurableFieldValueResponse,
  IInventory,
  IReference,
  IReferenceCategoryResponse,
  IUploadFileToDMS,
} from '@shared/interfaces';
import { generateFileTypeRegex } from '@shared/utils';

import { DateTimeFormatService } from '../../../../services/date-time-format.service';
import { FilesService } from '../../../../services/files.service';
import { FlowControlService } from '../../../../services/flow-control.service';
import {
  SnackbarService,
  SUCCESS_TYPES,
} from '../../../../services/snackbar.service';
import { UserInfoResponseDTO } from '../../../auth/services';
import {
  ReferenceCategoryService,
  ReferenceService,
} from '../../../references/services';
import { CONFIRMATION_TYPES } from '../../../shared/services/get-user-confirmation/constants';
import { GetUserConfirmationService } from '../../../shared/services/get-user-confirmation/service';
import { InventoryService } from '../../services/inventory.service';

// const imageRegex = /image\/*/;

const ACTIONS = {
  DOWNLOAD: 'DOWNLOAD',
  DELETE: 'DELETE',
};

const DOCUMENT_SAVE_STATUS = {
  SAVE: 'save',
  DRAFT: 'draft',
};

export enum TYPES {
  STATUS = 'Status',
}

export enum DOCUMENT_DATA_STATUS {
  PENDING_DELETE = 'Pending Delete',
}

export const getListValueFromReference = (
  reference: IConfigurableFieldValueResponse[],
  type: string
) => {
  return (
    reference
      ?.find(
        (ref) => ref?.field?.name?.toUpperCase()?.trim() === type.toUpperCase()
      )
      ?.value?.toString() || ''
  );
};

@Component({
  selector: 'app-add-edit-inventory',
  templateUrl: './add-edit-inventory.component.html',
  styleUrls: ['./add-edit-inventory.component.scss'],
})
export class AddEditInventoryComponent implements OnInit {
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;

  autoComplete: MatAutocompleteTrigger;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private flowControlService: FlowControlService,
    public translate: TranslateService,
    private snackbar: SnackbarService,
    private inventoryService: InventoryService,
    private referenceService: ReferenceService,
    private referenceCategoryService: ReferenceCategoryService,
    private dateTimeFormatService: DateTimeFormatService,
    private getUserConfirmation: GetUserConfirmationService,
    private filesService: FilesService
  ) {
    this.flowControlService.updateRouteInfo(
      this.router.url.split('?')[0],
      this.route.snapshot.data
    );
  }
  isLoading = true;

  isDisableForm = false;
  todayDate = new Date();
  isView: false;
  isEdit = false;
  inventoryId: string;
  referenceCategories: IReferenceCategoryResponse[];
  categoriesList: ELAutocompleteElement<IReference>[] = [];
  filteredCategoryList: ELAutocompleteElement<IReference>[] = [];
  documents: IAttachmentDocument[] = [];
  documentsDataList: DataListTableElement[] = [];
  allowedTypesNames = '*.jpg/ *.png/ *.jpeg/';
  allowedTypesRegex = generateFileTypeRegex([FILE_TYPES.IMAGE]);
  toBeUploadedDocuments = [];
  toBeUploadedData = [];
  toBeDeletedData = [];
  featuredImage: string;
  DOCUMENT_SAVE_STATUS = DOCUMENT_SAVE_STATUS;

  loggedUserInfo: UserInfoResponseDTO;

  addEditInventoryFormGroup: FormGroup<{
    category: FormControl<string>;
    assetId: FormControl<string>;
    serialNumber: FormControl<string>;
    manufacture: FormControl<string>;
    vendor: FormControl<string>;
    model: FormControl<string>;
    purchase_date: FormControl<Date>;
    warranty_end_date: FormControl<Date>;
    description: FormControl<string>;
    asset_image: FormControl<File>;
  }>;

  selectable = true;
  removable = true;
  file: File;

  private _filterCategories(
    value: string
  ): ELAutocompleteElement<IReference>[] {
    const filterValue = value?.toLowerCase();
    return this.categoriesList.filter(
      (option) => option.displayValue.toLowerCase().indexOf(filterValue) === 0
    );
  }

  listenToReferences() {
    this.referenceCategoryService.allCategories.subscribe(async (data) => {
      if (data && data.length === 0) {
        await this.referenceCategoryService.getAllReferenceCategories();
      }
      if (
        this.referenceCategories?.length === 0 ||
        this.referenceCategories === undefined
      ) {
        this.referenceCategories = data;

        const categoriesId = this.referenceCategories.find((category) => {
          return (
            INVENTORY_REFERENCE_SECTION.ASSET.toUpperCase() ===
              category.section.toUpperCase() &&
            category?.name?.trim()?.toUpperCase() ===
              INVENTORY_REFERENCE_CATEGORIES.CATEGORY.toUpperCase()
          );
        })?._id;

        if (categoriesId) {
          await this.referenceService
            .getReferences(categoriesId?.toString())
            .then((data) => {
              this.categoriesList = [];
              data?.forEach((data) => {
                data.reference?.forEach((ref) => {
                  if (
                    ref.field.name.toUpperCase() ===
                      ASSET_CATEGORY_REFERENCE_CATEGORY_FIELD.ASSET_CATEGORY.toUpperCase() &&
                    !data?.is_deleted
                  ) {
                    this.categoriesList.push({
                      displayValue: getListValueFromReference(
                        data?.reference,
                        ASSET_CATEGORY_REFERENCE_CATEGORY_FIELD.ASSET_CATEGORY
                      ),
                      value: data?._id?.toString(),
                    });
                  }
                });
              });
              //this.isLoading = false;
              this.addEditInventoryFormGroup.controls.category.valueChanges
                .pipe(
                  startWith(''),
                  map((value) => this._filterCategories(value))
                )
                .subscribe((res) => {
                  this.filteredCategoryList = res;
                });
            })

            .catch((error) => {
              console.error('Error fetching references:', error);
              this.isLoading = false;
            });
        }
      }
    });
  }

  ngOnInit(): void {
    this.listenToReferences();
    this.editInit();
    this.addEditInventoryFormGroup = new FormGroup({
      category: new FormControl(null, [Validators.required]),
      assetId: new FormControl(null, [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      serialNumber: new FormControl(null, []),
      manufacture: new FormControl(null, []),
      vendor: new FormControl(null, []),
      model: new FormControl(null, []),
      purchase_date: new FormControl(null),
      warranty_end_date: new FormControl(null),
      description: new FormControl(null),
      asset_image: new FormControl(null),
    });
  }

  editInit() {
    this.inventoryId = this.route.snapshot.params.id;
    if (this.inventoryId) {
      this.isEdit = true;
      this.getInventory();
    } else {
      this.isLoading = false;
    }
  }
  getInventory(): void {
    this.isLoading = true;
    this.inventoryService.getInventoryById(this.inventoryId).subscribe({
      next: async (res) => {
        const inventory = res.data;
        this.addEditInventoryFormGroup.patchValue({
          category: inventory.category,
          assetId: inventory.assetId,
          serialNumber: inventory.serialNumber,
          manufacture: inventory.manufacture,
          vendor: inventory.vendor,
          model: inventory.model,
          purchase_date: inventory.purchase_date,
          warranty_end_date: inventory.warranty_end_date,
          description: inventory.description,
        });
        if (inventory.asset_image || inventory.asset_image.length > 0) {
          inventory?.asset_image?.forEach((id) => {
            this.addToDataListTable({
              name: id.name,
              file_id: id.file_id,
              type: id.type,
              uploaded_date: id.uploaded_date,
              status: AttachmentStatus.UPLOADED,
            });
          });
        }
      },
      error: () => {
        this.router.navigate(['error']);
      },
      complete: () => {
        // End loading once the data has been fully processed
        this.isLoading = false;
      },
    });
  }

  async uploadFiles() {
    let uploadDataLength = this.toBeUploadedData.length;

    let uploadData: IUploadFileToDMS<File>;

    for (uploadData of this.toBeUploadedData) {
      this.isLoading = true;

      const index = this.documentsDataList.length - uploadDataLength--;

      await new Promise<void>((resolve, reject) => {
        this.filesService.uploadFileToDMS(uploadData).subscribe({
          next: (res) => {
            const file: IAttachmentDocument = {
              ...document,
              type: res.data.type,
              status: AttachmentStatus.UPLOADED,
              file_id: res.data._id.toString(),
              name: uploadData.file.name,
              uploaded_date: res.data.last_modified_on,
            };

            this.updateDataListTableElement(index, file);
            this.snackbar.success(
              SUCCESS_TYPES.SAVED,
              this.translate.instant('messages.files')
            );

            resolve();
          },
          error: () => {
            const file: IAttachmentDocument = {
              ...document,
              status: AttachmentStatus.FAILED,
              name: '',
              type: '',
              uploaded_date: undefined,
            };

            this.updateDataListTableElement(index, file);

            this.snackbar.error(
              this.translate.instant('messages.document.upload-failed')
            );
            reject(
              new Error(
                this.translate.instant('messages.document.upload-failed')
              )
            );
          },
        });
      });
    }
  }

  setCategoryData(category: string) {
    this.addEditInventoryFormGroup.controls.category.setValue(category);
  }

  removeFromDataListTable(index: number) {
    this.documentsDataList.splice(index, 1);
    this.documents.splice(index, 1);
    this.documentsDataList.forEach((element, index) => {
      element.index = index;
    });
  }

  async deleteFiles() {
    this.documentsDataList
      .map((obj, index) =>
        obj.data.some(
          (entry: { key: string; value: string }) =>
            entry.key === TYPES.STATUS &&
            entry.value === DOCUMENT_DATA_STATUS.PENDING_DELETE
        )
          ? this.removeFromDataListTable(index)
          : -1
      )
      .filter((index) => index !== -1);

    if (this.toBeDeletedData.length > 0) {
      this.toBeDeletedData.forEach(async (data) => {
        const index = this.documents.findIndex((item) => item === data);
        await new Promise<void>((resolve, reject) => {
          this.filesService.deleteEntityFromDMS(data.file_id).subscribe({
            next: () => {
              this.documents.splice(index, 1);

              resolve();
            },
            error: (e) => {
              reject(e);
            },
          });
        });
      });
    }
  }

  async uploadFilesToDMS() {
    if (this.toBeUploadedData.length) await this.uploadFiles();
    if (this.toBeDeletedData.length) await this.deleteFiles();
  }

  getStatusChip(document: IAttachmentDocument): DataListTableChipDataElement {
    let value: string;
    let chipBackgroundColor: string;
    switch (document.status) {
      case AttachmentStatus.UPLOADED:
        value = this.translate.instant('notices.notice-fields.uploaded');
        chipBackgroundColor = CHIP_BACKGROUND_COLORS.UPLOADED;
        break;

      case AttachmentStatus.FAILED:
        value = this.translate.instant('notices.notice-fields.failed');
        chipBackgroundColor = CHIP_BACKGROUND_COLORS.FAILED;
        break;

      case AttachmentStatus.UPLOADING:
        value = this.translate.instant('notices.notice-fields.uploading');
        chipBackgroundColor = CHIP_BACKGROUND_COLORS.UPLOADING;
        break;

      case AttachmentStatus.PENDING_UPLOAD:
        value = this.translate.instant('notices.notice-fields.pending-upload');
        chipBackgroundColor = CHIP_BACKGROUND_COLORS.PENDING_UPLOAD;
        break;

      case AttachmentStatus.PENDING_DELETE:
        value = this.translate.instant('notices.notice-fields.pending-delete');
        chipBackgroundColor = CHIP_BACKGROUND_COLORS.PENDING_DELETE;
        break;

      default:
        break;
    }
    return {
      key: this.translate.instant('notices.notice-fields.status'),
      value,
      type: DLT_DATA_TYPES.CHIP,
      chipBackgroundColor,
      chipColor: 'white',
    };
  }

  addToDataListTable(document: IAttachmentDocument) {
    const dataElements: DataListTableDataElement[] = [];
    const actionElements: DataListTableActionElement[] = [];

    dataElements.push(
      {
        key: this.translate.instant('notices.notice-fields.name'),
        value: document.name,
      },
      this.getStatusChip(document),
      {
        key: this.translate.instant('notices.notice-fields.date'),
        value: this.dateTimeFormatService.formatDateTime(
          document.uploaded_date
        ),
      }
    );

    actionElements.push(this.createDownloadAction(document));
    actionElements.push(this.createDeleteAction(document));

    this.documentsDataList.push({
      loading: document.status === AttachmentStatus.UPLOADING,
      expanded: document.status === AttachmentStatus.FAILED,
      data: dataElements,
      icon: 'description',
      actions: actionElements,
      index: this.documentsDataList.length,
    });
    this.documents.push(document);
  }

  private createDownloadAction(
    document: IAttachmentDocument
  ): DataListTableActionElement {
    return {
      icon: 'download',
      face: '',
      tooltip: this.translate.instant('notices.notice-fields.download'),
      action: ACTIONS.DOWNLOAD,
      data: document,
      disabled: document.status !== AttachmentStatus.UPLOADED,
    };
  }

  private createDeleteAction(
    document: IAttachmentDocument
  ): DataListTableActionElement {
    return {
      icon: 'delete',
      face: '',
      tooltip: this.translate.instant('notices.notice-fields.delete'),
      action: ACTIONS.DELETE,
      data: document,
    };
  }

  triggerFileSelected(file: File) {
    const document: IAttachmentDocument = {
      name: file.name,
      uploaded_date: new Date(),
      type: 'image',
      status: AttachmentStatus.UPLOADING,
    };

    this.saveDocument(document, file);
  }

  saveDocument(document: IAttachmentDocument, file: File) {
    this.addEditInventoryFormGroup.markAllAsTouched();
    this.addEditInventoryFormGroup.markAsDirty();
    this.addEditInventoryFormGroup.updateValueAndValidity();

    const index = this.documentsDataList.length;
    this.addToDataListTable(document);

    const entity: IUploadFileToDMS<File> = {
      is_public: false,
      is_system: true,
      generate_name: true,
      path: 'Inventory',
      tags: ['Inventory'],
      file,
      author_quota: this.loggedUserInfo?.connection?.custom_quota,
    };

    const savedFile: IAttachmentDocument = {
      ...document,
      status: AttachmentStatus.PENDING_UPLOAD,
      file_id: (Math.random() * 25000).toString(),
    };

    this.updateDataListTableElement(index, savedFile);

    this.toBeUploadedData.push(entity);
    this.toBeUploadedDocuments.push(savedFile);
  }

  async updateDataListTableElement(
    index: number,
    document: IAttachmentDocument
  ) {
    const dataElements: DataListTableDataElement[] = [];
    const actionElements: DataListTableActionElement[] = [];
    if (document.status === AttachmentStatus.PENDING_UPLOAD) {
      dataElements.push(
        {
          key: this.translate.instant('knowledgebase.document.name'),
          value: document.name,
        },
        this.getStatusChip(document)
      );
    } else
      dataElements.push(
        {
          key: this.translate.instant('knowledgebase.document.name'),
          value: document.name,
        },
        this.getStatusChip(document),
        {
          key: this.translate.instant('knowledgebase.document.date'),
          value: this.dateTimeFormatService.formatDateTime(
            document.uploaded_date
          ),
        }
      );
    switch (document.status) {
      case AttachmentStatus.UPLOADING:
        break;

      case AttachmentStatus.PENDING_UPLOAD:
        actionElements.push(this.createDeleteAction(document));
        break;

      case AttachmentStatus.FAILED:
        actionElements.push(this.createDeleteAction(document));
        break;

      case AttachmentStatus.UPLOADED:
        actionElements.push(this.createDeleteAction(document));
        actionElements.push(this.createDownloadAction(document));
        break;

      case AttachmentStatus.PENDING_DELETE:
        actionElements.push(this.createDownloadAction(document));
        break;
    }

    this.documentsDataList[index] = {
      loading: document.status === AttachmentStatus.UPLOADING,
      expanded: document.status === AttachmentStatus.FAILED,
      data: dataElements,
      icon: 'insert_drive_file',
      actions: actionElements,
      index,
    };

    this.documents[index] = document;
  }

  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  optionPanelOpen() {
    this.autoComplete.openPanel();
  }

  close() {
    this.close();
  }

  action(e: { action: string; data: IAttachmentDocument; index: number }) {
    switch (e.action) {
      case ACTIONS.DELETE:
        this.deleteDocument(e.index, e.data);
        break;
      case ACTIONS.DOWNLOAD:
        this.downloadDocument(e.index, e.data);
        break;
      default:
        break;
    }
  }

  private changeLoadingState(index: number, is_loading: boolean) {
    this.documentsDataList[index].loading = is_loading;
    this.documentsDataList[index].expanded = !is_loading;
  }

  private downloadDocument(index: number, document: IAttachmentDocument) {
    this.changeLoadingState(index, true);
    this.filesService
      .downloadEntityFromDMS(document.file_id, document.name)
      .then(() => {
        this.changeLoadingState(index, false);
        this.snackbar.success(SUCCESS_TYPES.DOWNLOADED, document.name);
      })
      .catch(() => {
        this.changeLoadingState(index, false);
        this.snackbar.error(
          this.translate.instant('knowledgebase.document.download-failed'),
          document.name
        );
      });
  }
  private deleteDocument(index: number, document: IAttachmentDocument) {
    if (document.status === AttachmentStatus.UPLOADING) {
      // should not be able to delete while uploading
      return;
    }

    if (document.status === AttachmentStatus.PENDING_UPLOAD) {
      this.documentsDataList.splice(index, 1);
      this.documents.splice(index, 1);
      return;
    }

    if (document.status === AttachmentStatus.FAILED) {
      // should be able to delete directly without confirmation
      this.documentsDataList.splice(index, 1);
      this.documents.splice(index, 1);
      return;
    }

    this.changeLoadingState(index, true);

    const dialogData = {
      description: this.translate.instant('knowledgebase.document.description'),
    };

    this.getUserConfirmation
      .confirm(CONFIRMATION_TYPES.DELETE, dialogData)
      .then(async (res: boolean) => {
        this.toBeDeletedData.push(document);

        if (res) {
          const savedFile: IAttachmentDocument = {
            ...document,
            status: AttachmentStatus.PENDING_DELETE,
          };

          this.updateDataListTableElement(index, savedFile);
        } else {
          this.snackbar.error(
            this.translate.instant('messages.snackbar.cant-delete')
          );
        }
      });
  }
  async onSave() {
    await this.uploadFilesToDMS();

    const postData: IInventory = {
      category: this.addEditInventoryFormGroup.get('category').value,
      assetId: this.addEditInventoryFormGroup.get('assetId').value,
      serialNumber: this.addEditInventoryFormGroup.get('serialNumber').value,
      manufacture: this.addEditInventoryFormGroup.get('manufacture').value,
      vendor: this.addEditInventoryFormGroup.get('vendor').value,
      model: this.addEditInventoryFormGroup.get('model').value,
      purchase_date: new Date(
        this.addEditInventoryFormGroup.get('purchase_date').value
      ),
      warranty_end_date: new Date(
        this.addEditInventoryFormGroup.get('warranty_end_date').value
      ),
      status: INVENTORY_STATUS.AVAILABLE,
      description: this.addEditInventoryFormGroup.get('description').value,
      asset_image: this.documents,
    };

    this.inventoryService.createInventory(postData).subscribe({
      next: (response) => {
        this.snackbar.success(
          SUCCESS_TYPES.ADDED,
          this.translate.instant('inventory.add-edit.form.asset')
        );

        this.router.navigate(['/app/inventory/'], {
          queryParams: {
            is_search: true,
            assetId: response.data.assetId,
          },
        });
      },
      error: () => {
        this.snackbar.error(
          this.translate.instant('inventory.add-edit.form.on-create-error')
        );
      },
    });
  }

  onUpdate() {
    const postData: IInventory = {
      category: this.addEditInventoryFormGroup.get('category').value,
      assetId: this.addEditInventoryFormGroup.get('assetId').value,
      serialNumber: this.addEditInventoryFormGroup.get('serialNumber').value,
      manufacture: this.addEditInventoryFormGroup.get('manufacture').value,
      vendor: this.addEditInventoryFormGroup.get('vendor').value,
      model: this.addEditInventoryFormGroup.get('model').value,
      purchase_date: new Date(
        this.addEditInventoryFormGroup.get('purchase_date').value
      ),
      warranty_end_date: new Date(
        this.addEditInventoryFormGroup.get('warranty_end_date').value
      ),
      status: INVENTORY_STATUS.AVAILABLE,
      description: this.addEditInventoryFormGroup.get('description').value,
      asset_image: this.documents,
    };

    this.inventoryService
      .updateInventoryById(postData, this.inventoryId)
      .subscribe({
        next: (response) => {
          this.snackbar.success(
            SUCCESS_TYPES.UPDATED,
            this.translate.instant('inventory.add-edit.form.asset')
          );

          this.router.navigate(['/app/inventory/'], {
            queryParams: {
              is_search: true,
              assetId: response.data.assetId,
            },
          });
        },
        error: () => {
          this.snackbar.error(
            this.translate.instant('inventory.add-edit.form.on-update.error')
          );
        },
      });
  }
}
